import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import '../Styles/Blog.css';

const LAST_UPDATED = '9 August 2026';
const CONTACT_EMAIL = 'hello@ppstudio.com';
const CONTROLLER = 'Pooja Biswal, trading as PP Studio';

export default function PrivacyPolicy() {
  return (
    <div className="blog-page">
      <Navbar />

      <div className="privacy-page">
        <div className="privacy-container">
          <header className="privacy-header">
            <p className="privacy-kicker">Legal</p>
            <h1>Privacy Policy</h1>
            <p className="privacy-updated">Last updated: {LAST_UPDATED}</p>
          </header>

          <div className="privacy-body">

            <h2>Who we are</h2>
            <p>
              This website (<strong>pp-studio-website.web.app</strong>) is operated by{' '}
              <strong>{CONTROLLER}</strong>, based in London, United Kingdom.
              Pooja Biswal is the data controller for all personal data collected through this site.
            </p>

            <h2>What data we collect and why</h2>

            <h3>Contact form</h3>
            <p>
              When you submit the contact form, we collect your name, email address, and message.
              This data is stored in Firebase Firestore and used solely to respond to your enquiry.
              We do not use it for marketing without your explicit consent.
            </p>

            <h3>Comments</h3>
            <p>
              If you leave a comment on a blog post or contract tip, we collect your name, email address,
              and comment text. Comments are held for moderation before publication.
              Your email address is not displayed publicly.
            </p>

            <h3>Analytics</h3>
            <p>
              This site uses Firebase Analytics (powered by Google Analytics 4).
              It collects anonymised usage data — pages visited, session duration, device type, and
              approximate country — to help us understand what content is useful.
              No personally identifiable information is linked to analytics data.
              You can opt out at any time using the <strong>Decline</strong> button in the cookie banner.
            </p>

            <h3>Podcast</h3>
            <p>
              Episode play counts are tracked anonymously. No account or login is required to listen.
            </p>

            <h3>AI assistant ("Ask Pooja")</h3>
            <p>
              This site includes an AI assistant that answers general questions about contracts, freelancing,
              and Pooja's content. It responds in whichever language you write in — currently
              <strong> English, French, German, Italian, Spanish, Hindi, and Odia</strong>. When you send it
              a message, that message and your recent conversation history are sent to our AI provider,{' '}
              <strong>Groq, Inc.</strong>, to generate a reply — this happens in real time and is not stored
              in our own database. Groq processes the request under its own terms — see their{' '}
              <a href="https://groq.com/privacy-policy/" target="_blank" rel="noreferrer">privacy policy</a>{' '}
              for details on how they handle data sent to their service.
            </p>
            <p>
              Please do not share confidential information, full contract text, or personal data about
              yourself or others in this chat. It is not a substitute for legal advice, and anything sent to
              it should be treated as you would any other message sent over the internet to a third-party
              service. For anything sensitive, please contact Pooja directly instead.
            </p>

            <h2>Legal basis for processing (UK GDPR)</h2>
            <p>
              We process your personal data on the following legal bases:
            </p>
            <ul>
              <li><strong>Legitimate interests</strong> — responding to contact form enquiries and operating the AI assistant.</li>
              <li><strong>Consent</strong> — analytics cookies and comment publication.</li>
            </ul>

            <h2>Data storage and processors</h2>
            <p>
              Data is stored using <strong>Google Firebase</strong> (Firestore and Cloud Storage),
              hosted on Google Cloud infrastructure in the United States with EU Standard Contractual
              Clauses in place. Firebase is certified under ISO 27001 and SOC 1/2/3.
            </p>
            <p>
              Messages sent to the AI assistant are additionally processed by <strong>Groq, Inc.</strong>,
              our AI inference provider, solely to generate a reply in real time.
            </p>
            <p>
              We do not sell, rent, or share your personal data with any third parties for marketing purposes.
            </p>

            <h2>Retention</h2>
            <ul>
              <li>Contact form messages — retained for up to 2 years, then deleted.</li>
              <li>Approved comments — retained indefinitely as part of published content, unless deletion is requested.</li>
              <li>Analytics data — retained for 14 months (Google Analytics default).</li>
            </ul>

            <h2>Your rights</h2>
            <p>Under UK GDPR you have the right to:</p>
            <ul>
              <li>Access the personal data we hold about you.</li>
              <li>Correct inaccurate data.</li>
              <li>Request deletion of your data.</li>
              <li>Object to processing based on legitimate interests.</li>
              <li>Withdraw consent at any time (analytics, comments).</li>
              <li>Lodge a complaint with the ICO (<a href="https://ico.org.uk" target="_blank" rel="noreferrer">ico.org.uk</a>).</li>
            </ul>
            <p>
              To exercise any of these rights, email us at{' '}
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
              We will respond within 30 days.
            </p>

            <h2>Cookies</h2>
            <p>
              We use the following cookies:
            </p>
            <table className="privacy-table">
              <thead>
                <tr><th>Cookie</th><th>Purpose</th><th>Duration</th></tr>
              </thead>
              <tbody>
                <tr><td>pp_cookie_consent</td><td>Stores your cookie preference</td><td>Permanent (localStorage)</td></tr>
                <tr><td>_ga, _ga_*</td><td>Google Analytics — anonymised usage stats</td><td>2 years (only if accepted)</td></tr>
                <tr><td>firebase:*</td><td>Firebase session persistence</td><td>Session</td></tr>
              </tbody>
            </table>

            <h2>Changes to this policy</h2>
            <p>
              We may update this policy from time to time. Material changes will be announced
              on the site. The "last updated" date at the top reflects the most recent revision.
            </p>

            <h2>Contact</h2>
            <p>
              For any privacy-related questions or data requests:{' '}
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </p>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
